var patterns = {
    '0': { regExp: /\d/ },
    // 'S': {pattern: /[a-zA-Z]/},
    // 'A': {pattern: /[0-9a-zA-Z]/},
    // 'U': {pattern: /[a-zA-Z]/, transform: v => v.toLocaleUpperCase()},
    // 'L': {pattern: /[a-zA-Z]/, transform: v => v.toLocaleLowerCase()}
};

export function applyMask ( value , mask,type ) {
    let output = "";
    let outputLength = 0;
    if (!value) {
      value = "";
    }
    if(!value && mask=='+7-000-000-00-00'){
        value = "+7";
    }

    value.split('').forEach( 
      symbol => {
        if ( outputLength >= mask.length ) {
          return;
        }

        var pattern = patterns[ mask[outputLength] ];

        if ( pattern ) {
          if ( pattern.regExp.test(symbol) ) {
            
            output += symbol;
            outputLength++;
          }
        } else {
          // Для вывода символов не соответствующих паттернам маски
          if ( symbol != mask[outputLength] ) {
              var pos = outputLength;
              var pattern = false;

              // Идем до следующего символа маски, который окажется паттерном
              while ( !pattern && pos <= mask.length ) {
                var notPatternSymbol = mask[pos];

                pattern = patterns[ notPatternSymbol ];

                if ( pattern ) {
                  // Если дошли до паттерна маски, то проверяем вводимый символ
                  if ( pattern.regExp.test(symbol) ) {
                    output += symbol;
                  }
                } else {
                    output += notPatternSymbol;
                }
                pos++;
              }
              
              outputLength = pos;
          } else {
              // Символы ввода и маски совпадают
              output += symbol;
              outputLength++;
          }

        }
      }
    );

    return { 
      value: output.trim(),
    //   gap
    };
}

// закомментированные значения могут вызывать проблемы при автопереводе (запятые в адресе заменятся на 'б')
var map = {
  '`' : 'ё',
  'q' : 'й', 'w' : 'ц', 'e' : 'у', 'r' : 'к', 't' : 'е', 'y' : 'н', 'u' : 'г', 'i' : 'ш', 'o' : 'щ', 'p' : 'з', '[' : 'х', ']' : 'ъ', 
  'a' : 'ф', 's' : 'ы', 'd' : 'в', 'f' : 'а', 'g' : 'п', 'h' : 'р', 'j' : 'о', 'k' : 'л', 'l' : 'д', ';' : 'ж',/* "'" : 'э',*/
  'z' : 'я', 'x' : 'ч', 'c' : 'с', 'v' : 'м', 'b' : 'и', 'n' : 'т', 'm' : 'ь', /*',' : 'б', '.' : 'ю',*/
  '~' : 'Ё',
  'Q' : 'Й', 'W' : 'Ц', 'E' : 'У', 'R' : 'К', 'T' : 'Е', 'Y' : 'Н', 'U' : 'Г', 'I' : 'Ш', 'O' : 'Щ', 'P' : 'З', '{' : 'Х', '}' : 'Ъ',
  'A' : 'Ф', 'S' : 'Ы', 'D' : 'В', 'F' : 'А', 'G' : 'П', 'H' : 'Р', 'J' : 'О', 'K' : 'Л', 'L' : 'Д',/* ':' : 'Ж', '"' : 'Э',*/
  'Z' : 'Я', 'X' : 'Ч', 'C' : 'С', 'V' : 'М', 'B' : 'И', 'N' : 'Т', 'M' : 'Ь', /*'<' : 'Б', '>' : 'Ю'*/
};

// var map = {
//   '`' : 'ё',
//   'q' : 'й', 'w' : 'ц', 'e' : 'у', 'r' : 'к', 't' : 'е', 'y' : 'н', 'u' : 'г', 'i' : 'ш', 'o' : 'щ', 'p' : 'з', '[' : 'х', ']' : 'ъ', 
//   'a' : 'ф', 's' : 'ы', 'd' : 'в', 'f' : 'а', 'g' : 'п', 'h' : 'р', 'j' : 'о', 'k' : 'л', 'l' : 'д', ';' : 'ж',"'" : 'э',
//   'z' : 'я', 'x' : 'ч', 'c' : 'с', 'v' : 'м', 'b' : 'и', 'n' : 'т', 'm' : 'ь', ',' : 'б', '.' : 'ю',
//   '~' : 'Ё',
//   'Q' : 'Й', 'W' : 'Ц', 'E' : 'У', 'R' : 'К', 'T' : 'Е', 'Y' : 'Н', 'U' : 'Г', 'I' : 'Ш', 'O' : 'Щ', 'P' : 'З', '{' : 'Х', '}' : 'Ъ',
//   'A' : 'Ф', 'S' : 'Ы', 'D' : 'В', 'F' : 'А', 'G' : 'П', 'H' : 'Р', 'J' : 'О', 'K' : 'Л', 'L' : 'Д',':' : 'Ж', '"' : 'Э',
//   'Z' : 'Я', 'X' : 'Ч', 'C' : 'С', 'V' : 'М', 'B' : 'И', 'N' : 'Т', 'M' : 'Ь', '<' : 'Б', '>' : 'Ю'
// };

export function replaceToCyrilic(value) {
  var val = "";
  for (var i = 0; i < value.length; i++) {
      if (map[value[i]]) {
          val += map[value[i]];
      } else {
          val += value[i];
      }
  }
  return val;
}

// Получение текущей позиции курсора (для проверки на первую цифру в телефоне)
function getCaretPosition(ctrl) {
  // IE < 9 Support
  if (document.selection) {
      ctrl.focus();
      var range = document.selection.createRange();
      var rangelen = range.text.length;
      range.moveStart('character', -ctrl.value.length);
      var start = range.text.length - rangelen;
      return {'start': start, 'end': start + rangelen};
  }
  // IE >=9 and other browsers
  else if (ctrl.selectionStart || ctrl.selectionStart == '0') {
      return {'start': ctrl.selectionStart, 'end': ctrl.selectionEnd};
  } else {
      return {'start': 0, 'end': 0};
  }
}